export const commonAuditEvents = {
    /**
     * Event is sent when user use search in page header (like custom fields/portfolios/customers and etc).
     */
    localSearchApplied: `Local Search Applied`,
    /**
     * Event is sent when user use undo button in page header.
     *
     * Payload: { operation: string }
     */
    undoApplied: `Undo Applied`,
    redoApplied: `Redo Applied`,
} as const;
